import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: { fontSize: 16, padding: 75 },
    header: {
        backgroundColor: "#135597", color: "white", padding: 10, textAlign: "center",
        marginBottom: 20,
        border: "1px solid #135597", borderRadius: "5px"
    },
    section: { marginBottom: 15 },
    table: { display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderColor: "#ddd" },
    tableRow: { flexDirection: "row" },
    tableCol: { borderStyle: "solid", borderWidth: 1, borderColor: "#ddd", padding: 5 },
    tableHeader: { backgroundColor: "#f4f4f4", fontWeight: "bold" },
    footer: { fontSize: 10, textAlign: "center", marginTop: "auto", color: "#999" },
    workshop: {
        fontSize: 24, backgroundColor: "#135597", color: 'white',
        border: "1px solid #135597", borderRadius: "5px", padding: "20", margin: "10px 5px"
    },
    workshopSection: { margin: 'auto' },
    workshopCenter: { margin: 'auto' },
    workshopSmallText: { fontSize: 16 },
});

const BookingPDF = ({ workshops, userInfo, plannedBookings, morningLocation, eveningLocation }) => {

    const workshopMap = {};
    workshops.forEach(ws => {
        workshopMap[ws.documentId] = ws.name;
    });

    const locationMap = {};
    workshops.forEach(ws => {
        locationMap[ws.documentId] = ws.location;
    });

    userInfo.morning_workshop_title = workshopMap[userInfo.morning_workshop]
    userInfo.evening_workshop_title = workshopMap[userInfo.evening_workshop]

    plannedBookings = plannedBookings.map(bk => ({
        ...bk,
        morning_workshop_title: workshopMap[bk.morning_workshop],
        evening_workshop_title: workshopMap[bk.evening_workshop]
    }));

    if (plannedBookings.length < 1) {

        const styles = StyleSheet.create({
            page: { fontSize: 16, padding: 75 },
            header: {
                backgroundColor: "#135597", color: "white", padding: 10, textAlign: "center",
                marginBottom: 20,
                border: "1px solid #135597", borderRadius: "5px"
            },
            section: { marginBottom: 15 },
            table: { display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderColor: "#ddd" },
            tableRow: { flexDirection: "row" },
            tableCol: { borderStyle: "solid", borderWidth: 1, borderColor: "#ddd", padding: 5 },
            tableHeader: { backgroundColor: "#f4f4f4", fontWeight: "bold" },
            footer: { fontSize: 10, textAlign: "center", marginTop: "auto", color: "#999" },
            workshop: {
                fontSize: 24, backgroundColor: "#135597", color: 'white',
                border: "1px solid #135597", borderRadius: "5px", padding: "20", margin: "10px 5px"
            },
            workshopSection: { margin: 'auto' },
            workshopCenter: { margin: 'auto' },
            workshopSmallText: { fontSize: 16 },
        });

        return (
            <Document>
                <Page style={styles.page}>
                    <Text style={styles.header}>Broneeringu ülevaade</Text>

                    <View style={styles.section}>
                        <Text>"Karjääriredel viib kosmosesse" karjääripäev toimub Tartu Tamme Gümnaasiumis, Nooruse 9,
                            Tartus. Palume 8. oktoobril kohal olla hiljemalt 9.30, et jõuaksite registreeruda.</Text>
                    </View>

                    <Text>Broneerija nimi: {userInfo.first_name} {userInfo.last_name}</Text>

                    <View style={styles.workshopSection}>
                        <View style={styles.workshop}>
                            <Text style={styles.workshopSmallText}>Hommikune töötuba (10.00 - 12.00)</Text>
                            <Text>{userInfo.morning_workshop_title || '—'}</Text>
                            <Text style={styles.workshopSmallText}>{morningLocation || '—'}</Text>
                        </View>
                        <View style={styles.workshop}>
                            <Text style={styles.workshopSmallText}>Õhtune töötuba (13.00 - 14.30)</Text>
                            <Text>{userInfo.evening_workshop_title || '—'}</Text>
                            <Text style={styles.workshopSmallText}>{eveningLocation || '—'}</Text>

                        </View>
                    </View>

                    <Text style={styles.footer}>
                        Küsimuste korral palun kirjutage: esero@ut.ee
                    </Text>
                </Page>
            </Document>
        );
    } else {
        const styles = StyleSheet.create({
            page: { fontSize: 12, padding: 75 },
            header: {
                backgroundColor: "#135597", color: "white", padding: 10, textAlign: "center",
                marginBottom: 20,
                border: "1px solid #135597", borderRadius: "5px"
            },
            section: { marginBottom: 15 },
            table: { display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderColor: "#ddd" },
            tableRow: { flexDirection: "row" },
            tableCol: { borderStyle: "solid", borderWidth: 1, borderColor: "#ddd", padding: 5 },
            tableHeader: { backgroundColor: "#f4f4f4", fontWeight: "bold" },
            footer: { fontSize: 10, textAlign: "center", marginTop: "auto", color: "#999" },
            workshop: {
                fontSize: 24, backgroundColor: "#135597", color: 'white',
                border: "1px solid #135597", borderRadius: "5px", padding: "20", margin: "10px 5px"
            },
            workshopSection: { margin: 'auto' },
            workshopCenter: { margin: 'auto' },
            workshopSmallText: { fontSize: 16 },
        });
        return (
            <Document>
                <Page style={styles.page}>
                    <Text style={styles.header}>Broneeringu ülevaade</Text>

                    <View style={styles.section}>
                        <Text>"Karjääriredel viib kosmosesse" karjääripäev toimub Tartu Tamme Gümnaasiumis, Nooruse 9,
                            Tartus. Palume 9. oktoobril kohal olla hiljemalt 9.30, et jõuaksite registreeruda ja tasuda 5 eurot osalustasu.</Text>
                    </View>

                    <View style={styles.section}>
                        <Text>Broneerija nimi: {userInfo.first_name} {userInfo.last_name}</Text>
                    </View>

                    <View style={styles.section}>
                        <Text>Õpilased:</Text>
                        <View style={styles.table}>
                            <View style={[styles.tableRow, styles.tableHeader]}>
                                <Text style={{ ...styles.tableCol, flex: 0.05 }}>#</Text>
                                <Text style={{ ...styles.tableCol, flex: 0.2 }}>Eesnimi</Text>
                                <Text style={{ ...styles.tableCol, flex: 0.2 }}>Perenimi</Text>
                                <Text style={{ ...styles.tableCol, flex: 0.27 }}>Hommikune töötuba</Text>
                                <Text style={{ ...styles.tableCol, flex: 0.28 }}>Õhtune töötuba</Text>
                            </View>
                            {plannedBookings.map((child, i) => (
                                <View style={styles.tableRow} key={child.uuid} wrap={false}>
                                    <Text style={{ ...styles.tableCol, flex: 0.05 }}>{i + 1}{'\n'}{'\n'}</Text>
                                    <Text style={{ ...styles.tableCol, flex: 0.2 }}>{child.first_name}</Text>
                                    <Text style={{ ...styles.tableCol, flex: 0.2 }}>{child.last_name}</Text>
                                    <Text style={{ ...styles.tableCol, flex: 0.27 }}>{child.morning_workshop_title || "—"}</Text>
                                    <Text style={{ ...styles.tableCol, flex: 0.28 }}>{child.evening_workshop_title || "—"}</Text>
                                </View>
                            ))}
                        </View>
                    </View>
                    <Text style={styles.footer}>
                        Küsimuste korral palun kirjutage: esero@ut.ee
                    </Text>
                </Page>
            </Document>
        );
    }

};

export default BookingPDF;
